import React, { Component, PropTypes } from "react";
import { Image, TouchableOpacity, Animated } from "react-native";
import TextView from "./TextView";
import { icons } from "../theme/icons";
import { styles, componentStyles } from "../theme/styles";
import { blueDarkColor, blueLightColor } from "../theme/colors";
import LinearGradient from 'react-native-linear-gradient';

class Button extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <TouchableOpacity activeOpacity={this.props.isdeactive ? 1.0 : 0.5}
                onPress={this.props.onPress}>
                <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[blueLightColor, blueDarkColor]} style={[componentStyles.gradinatButton, this.props.style]}>
                    {this.props.showArrow ? <Image source={icons['left_arrow']} style={componentStyles.smallIconWhite} /> : null}
                    <TextView isbold={this.props.isbold} numberOfLines={1} style={[this.props.textStyle, { flexGrow: 2 }]}>{this.props.text}</TextView>
                </LinearGradient>
            </TouchableOpacity>
        );
    }
}


export default Button;
